import {BehaviorSubject, tap} from 'rxjs';
import {BaseService} from '@esgi/core/service';
import {DownloadRequest, FileType, ReportRequest} from '../types';
import {SsoTracker} from '@esgi/core/tracker';
import {V2TeachersPagesReportsStudentDetailsController} from '@esgi/contracts/esgi';

export class DownloadService extends BaseService {
	public readonly busyController = new BehaviorSubject(false);
	private readonly controller = new V2TeachersPagesReportsStudentDetailsController();

	public override dispose() {
		this.controller.dispose();
	}

	public preview(request: ReportRequest) {
		this.busyController.next(true);
		return this.controller.report(request).pipe(
			tap(() => this.busyController.next(false)),
		);
	}

	public download({fileType, ...request}: DownloadRequest) {
		const documentDate = new Date().toLocaleDateString('en-US');
		SsoTracker.trackEvent({trackingEvent: 'PDF Standard', data: {reportType: 'Detail'}});

		this.httpClient.ESGIApi.file(
			'v2/teachers/pages/reports/student-details',
			'download-pdf',
			`Student_Detail_Report_${documentDate}.${fileType}`,
			{...request, zip: fileType === FileType.Zip}
		).subscribe();
	}
}
